<template>
  <div class="mv-bg-main">
    <el-row>
      <el-col :span="24">
        <el-card shadow="always">
          <div
            slot="header"
            style="text-align: center;"
            class="clearfix"
          >
            <span>企业客户详情</span>
          </div>
          <el-form
            ref="editCustInfor"
            :model="editCustInfor"
            label-width="120px"
          >
          <el-tabs v-model="activeName" >
            <el-tab-pane label="基本信息" name="first">
              <el-form
                ref="infoEssential"
                :model="infoEssential"
                label-width="120px">
                <el-form-item
                  label="客户名称"
                  prop="custName">
                  <el-input
                    disabled
                    v-model="infoEssential.custName"
                    placeholder="请输入客户名称"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="客户状态"
                  prop="custState">
                  <el-radio-group disabled v-model="infoEssential.custState">
                    <el-radio label="1">启用</el-radio>
                    <el-radio label="0">停用</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  label="客户来源"
                  prop="custSourceId">
                  <el-select
                    v-model="infoEssential.custSourceId"
                    placeholder="请选择客户来源"
                    disabled
                    clearable
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in source"
                      :key="item.custSourceId"
                      :label="item.custSourceName"
                      :value="item.custSourceId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="客户类型一级"
                  prop="custTypeId">
                  <el-select
                    v-model="infoEssential.custTypeId"
                    disabled
                    placeholder="请选择客户类型一级"
                    @change="changeOne"
                    clearable
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in typeOneData"
                      :key="item.custTypeId"
                      :label="item.custTypeNameCn"
                      :value="item.custTypeId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="客户类型二级"
                  prop="custTypeTwoId">
                  <el-select
                    v-model="infoEssential.custTypeTwoId"
                    disabled
                    placeholder="请选择客户类型二级"
                    clearable
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in typeTwoData"
                      :key="item.custTypeId"
                      :label="item.custTypeNameCn"
                      :value="item.custTypeId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="客户适用业务"
                  prop="custSysIds">
                  <el-select
                    v-model="infoEssential.custSysIds"
                    placeholder="请选择客户适用业务"
                    clearable
                    disabled
                    filterable
                    multiple
                    collapse-tags
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in sysData"
                      :key="item.systemId"
                      :label="item.systemName"
                      :value="item.systemId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="已报备的IP"
                  prop="ipaddress">
                  <el-input
                    type="textarea"
                    disabled
                    v-model="infoEssential.ipaddress"
                    placeholder="请输入已报备的IP"
                  ></el-input>
                  <p>注：多个IP时请用";"隔开，末尾处无需添加符号</p>
                </el-form-item>
                <div style="textAlign: center;margin:20px 0">
                  <el-button @click="returnList">关闭</el-button>
                  <!-- <el-button
                    type="primary"
                    @click="saveinfoEssential('infoEssential')"
                  >确 定</el-button> -->
                </div>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="联系人信息" name="second">
              <el-form
                ref="contactsInfo"
                :model="contactsInfo"
                label-width="120px">
                <el-form-item label="联系人姓名" prop="contacts">
                  <el-input
                    v-model="contactsInfo.contacts"
                    disabled
                    placeholder="请输入联系人姓名"
                    maxlength="16"
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系人号码" prop="conPhone">
                  <el-input
                    v-model="contactsInfo.conPhone"
                    disabled
                    placeholder="请输入联系人号码"
                    maxlength="11"
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系人邮箱" prop="conMail">
                  <el-input
                    maxlength="30"
                    disabled
                    v-model="contactsInfo.conMail"
                    placeholder="请输入联系人邮箱"
                  ></el-input>
                </el-form-item>
                <el-form-item label="性别" prop="sex">
                  <el-radio-group disabled v-model="contactsInfo.sex">
                    <el-radio label="0">男</el-radio>
                    <el-radio label="1">女</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="职务" prop="post">
                  <el-input
                    maxlength="60"
                    disabled
                    v-model="contactsInfo.post"
                    placeholder="请输入职务"
                  ></el-input>
                </el-form-item>
                <el-form-item label="生日" prop="date"  >
                  <el-date-picker
                    style="width: 100%;"
                    disabled
                    v-model="contactsInfo.date"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择生日">
                  </el-date-picker>
                </el-form-item>
                <div style="textAlign: center;margin:20px 0">
                  <el-button @click="returnList">关闭</el-button>
                  <!-- <el-button
                    type="primary"
                    @click="saveContactsInfo('contactsInfo')"
                  >确 定</el-button> -->
                </div>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="业务账户信息" name="third">
              <el-form
                ref="editCustInfor"
                :model="editCustInfor"
                label-width="120px">
                <!-- <el-button
                  size="small"
                  type="primary"
                  plain
                  @click="addAccount"
                >新增账户</el-button> -->
                <div
                  v-for="(item, index) in editCustInfor.accountDatas"
                  :key="item.key"
                  class="clearfix">
                  <el-col :span="20">
                    <el-form-item
                      label="账户"
                      :prop="'accountDatas.' + index +'.accName'"
                    >
                      <el-input
                        v-model="item.accName"
                        disabled
                        placeholder
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="密码"
                      :prop="'accountDatas.'+ index +'.accPwd'"
                    >
                      <el-input
                        v-model="item.accPwd"
                        disabled
                        placeholder
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="APIKey"
                      :prop="'accountDatas.'+ index +'.apiKey'"
                    >
                      <el-input
                        v-model="item.apiKey"
                        disabled
                        placeholder
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="账户状态"
                      :prop="'accountDatas.'+ index +'.status'"
                    >
                      <el-select
                        v-model="item.accStatus"
                        disabled
                        placeholder="请选择账户状态"
                        clearable
                        style="width:100%"
                      >
                        <el-option
                          v-for="item in accountStateData"
                          :key="item.id"
                          :label="item.value"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" :offset="1">
                    <!-- <el-button
                      class="float-r"
                      size="small"
                      icon="el-icon-delete"
                      @click.prevent="removeAccount(item)"
                      title="删除"
                    ></el-button> -->
                  </el-col>
                </div>
                <div style="textAlign: center;margin:20px 0">
                  <el-button @click="returnList">关闭</el-button>
                  <!-- <el-button
                    type="primary"
                    @click="saveAccount('editCustInfor')"
                  >确 定</el-button> -->
                </div>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="详细信息" name="fourth">
              <el-form
                ref="detailCustInfor"
                :model="detailCustInfor"
                label-width="120px">
                <el-form-item
                  prop="cusGrade"
                  label="客户等级">
                  <el-select
                    v-model="detailCustInfor.gradeCode"
                    placeholder="请选择客户等级"
                    clearable
                    disabled
                    filterable
                    style="width:100%">
                    <el-option
                      v-for="(item, index) in supLevelList"
                      :key="index"
                      :label="item.gradeName"
                      :value="item.gradeCode"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="所属行业" prop="industry">
                  <el-select
                    v-model="detailCustInfor.industry"
                    placeholder="请选择所属行业"
                    clearable
                    disabled
                    filterable
                    style="width:100%">
                    <el-option
                      v-for="(item, index) in industryData"
                      :key="index"
                      :label="item.industryName"
                      :value="item.industryCode"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  prop="idenType"
                  label="证件类型">
                  <el-select
                    v-model="detailCustInfor.idenType"
                    placeholder="请选择证件类型"
                    disabled
                    clearable
                    style="width:100%">
                    <el-option
                      label="身份证"
                      value="0"
                    ></el-option>
                    <el-option
                      label="护照"
                      value="1"
                    ></el-option>
                    <el-option
                      label="驾照"
                      value="2"
                    ></el-option>
                    <el-option
                      label="营业执照"
                      value="3"
                    ></el-option>
                    <el-option
                      label="社会统一使用代码"
                      value="4"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="证件号码"
                  prop="idenNum">
                  <el-input
                    v-model="detailCustInfor.idenNum"
                    disabled
                    placeholder
                  ></el-input>
                </el-form-item>
                <el-form-item label="地理位置" prop="province">
                  <el-select
                    v-model="detailCustInfor.province"
                    disabled
                    placeholder="请选择省"
                    clearable
                    :autocomplete="off"
                    @change="provinceChange"
                    filterable
                    style="width:217px">
                    <el-option
                      v-for="(item, index) in provinceData"
                      :key="index"
                      :label="item.name"
                      :value="item.short_code"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="detailCustInfor.city"
                    placeholder="请选择市"
                    @change="cityChange"
                    disabled
                    clearable
                    filterable
                    style="width:217px"
                  >
                    <el-option
                      v-for="(item, index) in cityData"
                      :key="index"
                      :label="item.name"
                      :value="item.short_code"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="detailCustInfor.area"
                    placeholder="请选择区"
                    disabled
                    clearable
                    filterable
                    style="width:217px"
                  >
                    <el-option
                      v-for="(item, index) in areaData"
                      :key="index"
                      :label="item.name"
                      :value="item.short_code"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="详细地址" prop="ipaddress">
                  <el-input
                    type="textarea"
                    v-model="detailCustInfor.ipaddress"
                    disabled
                    placeholder="请输入详细信息"
                  ></el-input>
                </el-form-item>
                <el-form-item label="介绍" prop="desc">
                  <el-input
                    type="textarea"
                    v-model="detailCustInfor.desc"
                    disabled
                    placeholder="请输入介绍"
                  ></el-input>
                </el-form-item>
                <div style="textAlign: center;margin:20px 0">
                  <el-button @click="returnList">关闭</el-button>
                  <!-- <el-button
                    type="primary"
                    @click="savedetailCustInfor('detailCustInfor')"
                  >确 定</el-button> -->
                </div>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="商务信息" name="five">
              <el-form
                ref="editCustInfor"
                :model="editCustInfor"
                label-width="120px">
                <el-form-item
                  label="商务经理"
                  prop="abuName"
                  v-show="!abuNameBlooen">
                  <el-select
                    v-model="editCustInfor.abuName"
                    disabled
                    placeholder="请选择商务经理"
                    clearable
                    filterable
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in abuNameData"
                      :key="item.userId"
                      :label="item.userName"
                      :value="item.userId"
                      @click.native="changeTemplate(item)"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="商务经理"
                  prop="abuName"
                  v-show="abuNameBlooen">
                  <el-input
                    v-model="editCustInfor.abuName"
                    placeholder="请输入商务经理名称"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="商务经理电话"
                  prop="abuMobile">
                  <el-input
                    disabled
                    v-model="editCustInfor.abuMobile"
                    placeholder
                    maxlength="11"
                  ></el-input>
                </el-form-item>
                <el-form-item label="商务经理邮箱" prop="busMail">
                  <el-input
                    maxlength="30"
                    disabled
                    v-model="editCustInfor.busMail"
                    placeholder="请输入商务经理邮箱"
                  ></el-input>
                </el-form-item>
                <div style="textAlign: center;margin:20px 0">
                  <el-button @click="returnList">关闭</el-button>
                  <!-- <el-button
                    type="primary"
                    @click="saveBusiness('editCustInfor')"
                  >确 定</el-button> -->
                </div>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="扩展信息" name="six">
              <el-form
                ref="editCustInfor"
                :model="editCustInfor"
                label-width="120px">
                <!-- <el-button
                    size="small"
                    type="primary"
                    plain
                    @click="addExtField"
                  >新增扩展属性</el-button> -->
                <div
                  v-for="(item, index) in editCustInfor.extFieldList"
                  class="clearfix"
                  :key="item.key">
                  <el-col :span="20">
                    <el-form-item
                      label="属性名"
                      :prop="'extFieldList.'+ index + '.name'"
                    >
                      <el-input disabled v-model="item.fieldName" placeholder></el-input>
                    </el-form-item>
                    <el-form-item
                      label="属性值"
                      :prop="'extFieldList.'+ index + 'value'"
                    >
                      <el-input disabled v-model="item.fieldValue" placeholder></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" :offset="1">
                    <!-- <el-button
                      class="float-r"
                      size="small"
                      icon="el-icon-delete"
                      @click.prevent="removeExtField(item)"
                      title="删除"
                    ></el-button> -->
                  </el-col>
                </div>
                <div style="textAlign: center;margin:20px 0">
                  <el-button @click="returnList">关闭</el-button>
                  <!-- <el-button
                    type="primary"
                    @click="saveExtFieldList('editCustInfor')"
                  >确 定</el-button> -->
                </div>
              </el-form>
            </el-tab-pane>
          </el-tabs>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      editCustInfor: {
        custName: '',
        custLoginName: '',
        custTypeName: '',
        custContractName: '',
        custPayName: '',
        custSourceName: '',
        custState: '',
        custSysNames: '',
        ipaddress: '',
        contacts: '',
        conPhone: '',
        conMail: '',
        abuId: '',
        abuName: '',
        abuMobile: '',
        /* 账户信息 */
        accountDatas: [
          {
            accId: '',
            accName: '', // 客户账户名称
            accPwd: '', // 客户账户密码
            apiKey: '', // 特殊字段
            status: '' // 账户状态
          }
        ],
        contractEffectiveDate: '',
        /* 合同附件 */
        contractFiles: []
      },
      num: '',
      source: [],
      typeOneData: [],
      sysData: [],
      typeTwoData: [],
      infoEssential: {
        custName: '',
        custId: '',
        custState: '',
        custSourceId: '',
        custTypeId: '',
        custTypeTwoId: '',
        custSysIds: [],
        ipAddress: ''
      },
      contactsInfo: {
        contacts: '',
        custId: '',
        conPhone: '',
        conMail: '',
        sex: '',
        post: '',
        date: ''
      },
      detailCustInfor: {
        gradeCode: '',
        custId: '',
        industry: '',
        idenType: '',
        idenNum: '',
        ipaddress: '',
        desc: '',
        area: '',
        city: '',
        province: ''
      },
      /* 账户状态 */
      accountStateData: [
        {
          id: '1',
          value: '有效'
        },
        {
          id: '0',
          value: '无效'
        }
      ],
      activeName: 'first',
      abuNameData: [],
      supLevelList: [],
      accountData: [],
      custTypeData: [],
      industryData: [],
      provinceData: [],
      cityData: [],
      areaData: [],
      abuNameBlooen: false,
      off: 'off',
      size: '',
      page: {
        num: 1,
        sizeSmall: 10,
        size: 100
      },
      uploadFile: this.$API.fileUpload,
      headers: {
        mtk: localStorage.getItem('usermtk')
      }
    }
  },
  created () {
    if (this.$route.query.num) {
      this.num = this.$route.query.num
      this.size = this.$route.query.size
    }
    let _this = this
    this.$http({
      method: 'get',
      url: _this.$API.supplier.queryAddrCode
    }).then((response) => {
      let data = response.data.resData
      _this.provinceData = data
      _this.queryDetail(_this.$route.query.custId)
      console.log(_this.provinceData)
    }).catch((error) => {
      console.log(error)
    })
    this.$http({
      method: 'get',
      url: _this.$API.supplier.queryIndustryCode
    }).then((response) => {
      console.log(response.data)
      let data = response.data.resData
      _this.industryData = data.industryInfos
    }).catch((error) => {
      console.log(error)
    })
    this.$http({
      method: 'get',
      url: _this.$API.supplier.queryGradeCode
    }).then((response) => {
      console.log(response.data)
      let data = response.data.resData
      this.supLevelList = data.gradeInfos
    }).catch((error) => {
      console.log(error)
    })
    /* 查询商务经理列表 */
    let type = {abuType: 2}
    this.$axios
      .get(_this.$API.supplier.queryBusinessMangerList, {params: type})
      .then(function (r) {
        _this.abuNameData = r.data.resData.userList
        _this.queryBusiness(_this.$route.query.custId)
      })
      .catch(function (error) { console.log(error) })
    this.queryDefaultList()
    this.queryEditDetail(this.$route.query.custId)
    this.queryContact(this.$route.query.custId)
    this.queryAccount(this.$route.query.custId)
    this.queryExtInfoById(this.$route.query.custId)
  },
  methods: {
    queryDefaultList () {
      let _self = this
      let params = {
        pageNum: this.page.num,
        pageSize: this.page.size
      }
      /* 查询客户来源 */
      this.$axios
        .get(this.$API.customerManagement.queryCustFromList)
        .then(function (r) {
          _self.source = r.data.resData
        })
        .catch(function (error) { console.log(error) })
      /* 查询客户类型1级 */
      this.$axios
        .get(this.$API.customerManagement.queryCustTypeFirst)
        .then(function (r) {
          _self.typeOneData = r.data.resData
        })
        .catch(function (error) { console.log(error) })
      /* 查询客户适应业务系统列表 */
      this.$axios
        .post(this.$API.apiList.querySysList, params)
        .then(function (r) {
          _self.sysData = r.data.resData
        })
        .catch(function (error) { console.log(error) })
    },
    /* 查询基本信息 */
    queryEditDetail (custId) {
      let params = {
        custId: custId
      }
      let _self = this
      this.$axios
        .post(this.$API.customerManagement.querycompCustInfoCtrInfoById, params)
        .then(function (r) {
          let data = r.data.resData
          console.log(data)
          // 如果有一级查询对应二级客户类型
          if (data.custTypeFirst) {
            _self.changeOne(data.custTypeFirst)
          }
          _self.infoEssential.custId = data.custId
          _self.infoEssential.custName = data.custName
          _self.infoEssential.custState = data.custState
          _self.infoEssential.custSourceId = data.custSourceId
          _self.infoEssential.custTypeId = data.custTypeFirst
          _self.infoEssential.custTypeTwoId = data.custTypeSecond
          _self.infoEssential.custSysIds = data.custSysIds ? data.custSysIds.split(',').map(Number) : []
          _self.infoEssential.ipaddress = data.ipaddress
        })
        .catch(function (error) { console.log(error) })
    },
    /* 查询联系人信息 */
    queryContact (custId) {
      let params = {
        custId: custId
      }
      let _self = this
      this.$axios
        .post(this.$API.customerManagement.queryContactInfoById, params)
        .then(function (r) {
          let data = r.data.resData
          console.log(data)
          _self.contactsInfo.custId = data.custId
          _self.contactsInfo.contacts = data.contactName
          _self.contactsInfo.conPhone = data.contactTel
          _self.contactsInfo.conMail = data.contactMail
          _self.contactsInfo.sex = data.sex
          _self.contactsInfo.post = data.contactPosition
          _self.contactsInfo.date = data.birthday
          _self.contactsInfo.custId = data.custId
        })
        .catch(function (error) { console.log(error) })
    },
    provinceChange (val) {
      console.log(val)
      console.log(this.provinceData)
      if (val && val !== 0) {
        for (let v of this.provinceData) {
          if (v.short_code === val) {
            console.log(v)
            this.cityData = v.city
          }
        }
      } else {
        this.cityData = []
        this.areaData = []
      }
      console.log(this.cityData)
    },
    /* 查询详细信息 */
    queryDetail (custId) {
      let params = {
        custId: custId
      }
      let _self = this
      this.$axios
        .post(this.$API.customerManagement.querycompDeatilById, params)
        .then(function (r) {
          let data = r.data.resData
          _self.detailCustInfor.custId = data.custId
          _self.detailCustInfor.gradeCode = data.custLevelCode
          _self.detailCustInfor.industry = data.industryCode
          _self.detailCustInfor.idenType = data.cardType
          _self.detailCustInfor.idenNum = data.cardNum
          _self.detailCustInfor.ipaddress = data.detailAddr
          _self.detailCustInfor.desc = data.introduce
          let where = null
          if (data.location) {
            where = data.location.split('-')
            console.log(where)
            _self.detailCustInfor.province = where[0]
            _self.detailCustInfor.city = where[1]
            _self.detailCustInfor.area = where[2]
            _self.provinceChange(where[0])
            _self.cityChange(where[1])
          }
          console.log(data)
        })
        .catch(function (error) { console.log(error) })
    },
    /* 查询账户信息 */
    queryAccount (custId) {
      let params = {
        custId: custId
      }
      let _self = this
      this.$axios
        .post(this.$API.customerManagement.queryAccInfoById, params)
        .then(function (r) {
          let data = r.data.resData
          _self.editCustInfor.accountDatas = data.accList
          console.log(data)
        })
        .catch(function (error) { console.log(error) })
    },
    /* 查询商务经理信息 */
    queryBusiness (custId) {
      let params = {
        custId: custId
      }
      let _self = this
      this.$axios
        .post(this.$API.customerManagement.queryAbuInfoById, params)
        .then(function (r) {
          let data = r.data.resData
          _self.editCustInfor.abuName = data.abuId
          if (data.abuId) {
            for (let v of _self.abuNameData) {
              if (data.abuId === v.userId) {
                _self.changeTemplate(v)
              }
            }
          }
          console.log(data)
        })
        .catch(function (error) { console.log(error) })
    },
    /* 选择商务经理联动商务经理电话 */
    changeTemplate (data) {
      // this.abuMobileBoolean = false
      this.editCustInfor.abuMobile = data.mobile
      this.editCustInfor.busMail = data.email
    },
    /* 查询扩展信息 */
    queryExtInfoById (custId) {
      let params = {
        custId: custId
      }
      let _self = this
      this.$axios
        .post(this.$API.customerManagement.queryExtInfoById, params)
        .then(function (r) {
          let data = r.data.resData
          _self.editCustInfor.extFieldList = data.extFieldList
          // for (let v of _self.editCustInfor.extFieldList) {
          //   v.name = v.fieldName
          //   v.value = v.fieldValue
          // }
          console.log(_self.editCustInfor.extFieldList)
        })
        .catch(function (error) { console.log(error) })
    },
    cityChange (val) {
      console.log(val)
      console.log(this.cityData)
      if (val && val !== 0) {
        for (let v of this.cityData) {
          if (v.short_code === val) {
            this.areaData = v.area
          }
        }
      } else {
        this.areaData = []
      }
    },
    changeOne (val) {
      // 根据客户类型一级查二级
      let params = { parentCustTypeId: val }
      let _this = this
      this.editCustInfor.custTypeTwoId = ''
      this.$axios
        .get(this.$API.customerManagement.queryCustTypeByParentCustTypeId, {
          params: params
        })
        .then(function (r) {
          _this.typeTwoData = r.data.resData
        })
        .catch(function (error) { console.log(error) })
    },
    /* 点击文件列表中已上传的文件时的钩子 */
    handlePreview (file) {
      let _width = window.outerWidth
      let _height = window.outerHeight
      window.open(file.url, '_blank', 'width=' + _width + ', height = ' + _height + ', menubar = no,toolbar = no, status = no, scrollbars = yes')
    },
    /* 返回列表 */
    returnList () {
      this.$router.push({
        path: '/customerInfor',
        query: {
          num: this.num,
          size: this.size
        }
      })
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.clearfix {
  @include clearfix;
}
.editMaintenance-title {
  padding-left: 20px;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/customerManagement/customerInforDetails.vue